export var getRoomTrackingData = function(room) {
    return {
        id: room.id,
        slug: room.slug,
        urlName: room.urlName,
        name: room.name
    };
};
